<template>
    <tr v-if="!readonly" class="action-row">
        <template v-if="layout === 'component-first'">
            <td></td>
            <td>
                <b-button
                    v-if="showAddComponent"
                    size="sm"
                    variant="outline-primary"
                    @click="$emit('add-component')"
                >
                    {{ addComponentText }}
                </b-button>
            </td>
            <td></td>
            <td>
                <b-button
                    v-if="showAddSubstance"
                    size="sm"
                    variant="outline-primary"
                    @click="$emit('add-substance')"
                >
                    {{ addSubstanceText }}
                </b-button>
            </td>
            <td></td>
            <td v-if="showComment"></td>
            <td></td>
            <td></td>
        </template>
        <template v-else>
            <td></td>
            <td>
                <b-button
                    v-if="showAddComponent"
                    size="sm"
                    variant="outline-primary"
                    @click="$emit('add-component')"
                >
                    {{ addComponentText }}
                </b-button>
            </td>
            <td>
                <b-button
                    v-if="showAddSubstance"
                    size="sm"
                    variant="outline-primary"
                    @click="$emit('add-substance')"
                >
                    {{ addSubstanceText }}
                </b-button>
            </td>
            <td></td>
            <td></td>
            <td v-if="showComment"></td>
            <td></td>
            <td></td>
        </template>
    </tr>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
    name: 'FmdActionsRow',
    components: {
        BButton,
    },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        showAddComponent: {
            type: Boolean,
            default: false,
        },
        showAddSubstance: {
            type: Boolean,
            default: false,
        },
        layout: {
            type: String,
            default: 'material-first',
        },
        addComponentText: {
            type: String,
            default: '',
        },
        addSubstanceText: {
            type: String,
            default: '',
        },
        showComment: {
            type: Boolean,
            default: true,
        },
    },
}
</script>
